import { OverlayRef } from '@angular/cdk/overlay';
import { Observable, Subject } from 'rxjs';

export class TooltipRef {
  private readonly _afterClosed$ = new Subject<void>();

  constructor(private readonly overlayRef: OverlayRef) {}

  public afterClosed$(): Observable<void> {
    return this._afterClosed$.asObservable();
  }

  public close(): void {
    this.overlayRef.detach();
    this._afterClosed$.next();
    this._afterClosed$.complete();
  }
}
